import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import "./Header.css";

const Header = () => {
  const { user, logOut } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    user?.email
      ? fetch(`https://apichothaon1-hzrifat.b4a.run/users/${user?.email}`)
          .then((res) => res.json())
          .then((data) => setIsAdmin(data?.isAdmin))
      : console.log("");
  }, [user?.email]);

  const activeStyle = {
    // textDecoration: 'underline',
    color: "rgb(252, 211, 5)",
  };

  return user?.email ? (
    <header
      style={{ position: "sticky", top: "0", zIndex: "4" }}
      className="bg-dark"
    >
      <div>
        <nav
          style={{ color: "white" }}
          className="d-flex justify-content-center"
        >
          <ul className="nav-style d-flex flex-wrap justify-content-center align-items-center my-auto">
            {isAdmin ? (
              <li style={{ marginLeft: "-23px" }}>
                <NavLink activeStyle={activeStyle} to="/manage">
                  Manage
                </NavLink>
              </li>
            ) : null}

            <li>
              <NavLink activeStyle={activeStyle} to="/collections">
                Collections
              </NavLink>
            </li>

            <li>
              <NavLink activeStyle={activeStyle} to="/upload">
                Upload
              </NavLink>
            </li>
            {user?.email && (
              <li className="text-success">{user?.displayName}</li>
            )}

            {!user?.photoURL && (
              <div
                className="me-3"
                style={{
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                  border: "1px solid rgba(255, 255, 255, 0.5)",
                  padding: "1px 7px",
                }}
              >
                <i className="fas fa-user fs-6"></i>
              </div>
            )}

            {user?.photoURL && (
              <img
                width={40}
                height={40}
                style={{ borderRadius: "50%" }}
                className="me-3"
                src={user?.auth?.currentUser?.photoURL}
                alt="pro-pic"
              />
            )}
            <li className="nav-item">
              <button onClick={logOut} className="btn btn-outline-light">
                Logout
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  ) : (
    <div></div>
  );
};

export default Header;
